import { Injectable } from '@angular/core';

import { BaseComponentResolver } from '../../../_base/base-component-resolver/base-component-resolver';

import { CmsComponentConfig, Member } from '@interfaces/config';
import { CmsComponentNodeData } from '@interfaces/cms-component-node-data';
import { TImageConfig, TMediaNodeType } from '@interfaces/media';

import { ParagraphMemberData } from '@generated/content';
import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';
import { CmsComponentTypeEnum } from '@models/enums';

@Injectable({ providedIn: 'root' })
export class MemberComponentResolver extends BaseComponentResolver {
  static override instance: MemberComponentResolver;
  private readonly componentType = Member.TypeEnum;

  static getInstance(): MemberComponentResolver {
    return (MemberComponentResolver.instance ||= new MemberComponentResolver());
  }

  public resolveComponentConfig(
    node: ParagraphMemberData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<Member.ComponentConfig> {
    if (!node) {
      return null;
    }

    this.nodePageData = nodePageData;
    const href = node.attributes.field_link_member?.url ?? null;
    const title = this.hyphenate(node.attributes.field_headline_member);
    const imageConfig = this.getImageConfig(node);

    imageConfig.fill = true;
    imageConfig.metas ||= {};
    imageConfig.metas.alt = title;
    imageConfig.sizes = MediaResolver.buildImageConfigSizes(CmsComponentTypeEnum.MEMBER);

    const config = {
      nodeId: BaseComponentResolver.getNodeId(node),
      imageConfig,
      title,
      role: this.hyphenate(node.attributes.field_sub_headline_member),
      description: this.hyphenate(node.attributes.field_description_member),
      link: {
        href,
        label: this.hyphenate(node.attributes.field_link_member?.title ?? null),
        external: href ? !href.startsWith('/') : false,
      },
    };

    return { componentType: this.componentType, config };
  }

  private getImageConfig(node: ParagraphMemberData): TImageConfig {
    if (!node?.relationships?.field_image_member?.data) {
      return null;
    }

    const { type, id } = node.relationships.field_image_member.data;
    return this.getMediaDataUrls(id, type as TMediaNodeType) || {};
  }
}
